import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { IToolbarDownloadsConfig } from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";
import DownloadButton from "../buttons/toolbar/DownloadButton";

interface IParams {
  contentId: number;
  downloadsConfig: IToolbarDownloadsConfig | undefined;
}

const DownloadButtonsContainer: React.FC<IParams> = ({
  downloadsConfig,
  contentId,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { toolbar, currentGalleryFile } = rootStore.commonStore;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {downloadsConfig &&
        toolbar!.downloadButtons.map((b, index) => (
          <React.Fragment key={`${b.type}-${index}`}>
            {b.type === "original" ? (
              <DownloadButton
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                button={b}
                contentId={contentId}
                url={`/content/${downloadsConfig.source}/${downloadsConfig.sourceId}/download/${contentId}?format=${b.type}`}
              />
            ) : (
              currentGalleryFile?.type !== "video" && (
                <DownloadButton
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  button={b}
                  contentId={contentId}
                  url={`/content/${downloadsConfig.source}/${downloadsConfig.sourceId}/download/${contentId}?format=${b.type}`}
                />
              )
            )}
          </React.Fragment>
        ))}
    </>
  );
};

export default observer(DownloadButtonsContainer);